import { Container, Paper, Stack } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { PluginsForm } from '../plugins-form'
import { useTranslation } from 'react-i18next'
import { TextFieldInput } from '../../../../inputs/text-field-input'
import { useMutation, useQuery } from '@apollo/client'
import { SectionHeader } from '@sitoo/mui-components'
import {
  GetSoftpayPluginDocument,
  PluginSoftpay,
  UpdateSoftpayDocument,
} from '../../../../generated/graphql'

type Form = PluginSoftpay

export const SettingsSoftpayPage = () => {
  const { t } = useTranslation(['shared', 'apps'])

  const formContext = useForm<Form>({
    defaultValues: {
      app_username: '',
      app_password: '',
    },
  })

  const { control } = formContext

  const { data } = useQuery(GetSoftpayPluginDocument, {
    fetchPolicy: 'cache-and-network',
  })

  const [updateSettings, { loading: isLoading }] = useMutation(
    UpdateSoftpayDocument,
  )

  const onSubmit = async (formData: Form) => {
    const { data } = await updateSettings({ variables: { data: formData } })

    return data?.updateSoftpay
  }

  return (
    <Container>
      <FormProvider {...formContext}>
        <PluginsForm
          serverData={data?.softpayPlugin}
          onSubmit={onSubmit}
          submitLabel={t('shared:action.save')}
          isLoading={isLoading}
        >
          <Paper>
            <SectionHeader variant="transparent">
              {t('apps:softpay.authentication_section')}
            </SectionHeader>

            <Stack gap={2} sx={{ p: 2, pt: 1 }}>
              <TextFieldInput
                name="app_username"
                control={control}
                label={t('apps:softpay.app_username_label')}
                helperText={t('apps:softpay.app_username_helper')}
              />

              <TextFieldInput
                name="app_password"
                type="password"
                control={control}
                label={t('apps:softpay.app_password_label')}
                helperText={t('apps:softpay.app_password_helper')}
              />
            </Stack>
          </Paper>
        </PluginsForm>
      </FormProvider>
    </Container>
  )
}
